import createApi from "../utils/apiClient";
const api = createApi();

export const getMaterials =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch({ type: "MATERIALS_REQUEST" });
      const { data } = await api.get("/study-materials", { params });
      dispatch({ type: "MATERIALS_SUCCESS", payload: data.materials });
    } catch (err) {
      dispatch({
        type: "MATERIALS_FAIL",
        payload: err.response?.data?.message,
      });
    }
  };

export const uploadMaterial = (formData) => async (dispatch) => {
  try {
    const { data } = await api.post("/study-materials", formData);
    dispatch(getMaterials());
    return data;
  } catch (err) {
    throw err;
  }
};

export const deleteMaterial = (id) => async (dispatch) => {
  try {
    await api.delete(`/study-materials/${id}`);
    dispatch(getMaterials());
  } catch (err) {
    throw err;
  }
};
